import styled from "styled-components"

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: ${({theme}) => theme.spacing.four} 0 ${({theme}) => theme.spacing.one};
`

export default HeaderWrapper
